export default __webpack_public_path__ + "static/media/htp.080d569e.png";